import TariffCalculate from './TariffCalculateContainer';

export { TariffCalculate };



// WEBPACK FOOTER //
// ./src/modules/home/tariffCalculate/index.js